import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import apiurl from './apiurl';
import axios from 'axios';
import swal from 'sweetalert';

export default class Opiniuj extends React.Component {
constructor(props) {
  super(props);    
  this.state = {
    token: sessionStorage.getItem('token'),
    status: "T",
    uwaga: props.uwagi,
  }

  this.getdata();
}


getdata = () => {
  axios
    .get(apiurl+"api/Listy/GetStatusyOpinie",{ params: { rok : this.props.rok }, headers: { 'Authorization' : "Bearer " + this.state.token }})
    .then(response =>
      this.setState({ statusydata : response.data }),
      
    )
    .catch(error => swal(error.response.data.messege) );
}


post = () => {
axios.post(apiurl+"api/Opinie/Post2",
    {idOpinia: this.props.idopini, rok: this.props.rok, idWydzialu: this.props.idWydzialu, status: this.state.status, uwaga: this.state.uwaga },
    {headers : {'Content-Type': 'application/json' , 'Authorization' : "Bearer " + this.state.token } })
    .then(res => {
      this.props.closeModal2();
    })
.catch(error => swal(error.response.data));
}

onChange = (e) => { this.setState({  [e.target.name]: e.target.value }); }


render() {
return (
<React.Fragment>
<div className="container-fluid">
<h1>Opiniuj</h1>
<hr />
<div className="d-flex flex-row">
<div class=" float-left mt-2 mb-4">
<span>Status:</span>
<select class="form-control" name="status" onChange={this.onChange.bind(this)}>
 <option key="1" value="T">Pozytywna</option>
 <option key="2" value="N">Negatywna</option>
 <option key="3" value="Z">Ignoruj</option>
</select>
</div>
</div>

<div className="d-flex flex-row">
<div class="flex-column w-100">
<span>Uzasadnienie:</span>
<textarea class="form-control" name="uwaga" value={this.state.uwaga} onChange={this.onChange.bind(this)} rows="6"></textarea>
</div>
</div>

<div className="d-flex flex-row">
<div class="flex-column w-100">
<button  onClick={() => {
  swal({
    title: "Czy na pewno chcesz zapisać?",
    buttons: {
    cancel: "Anuluj",
    catch: {
      text: "Zapisz",
      value: "willDelete",} 
    },
    dangerMode: true,
  })
  .then((willDelete) => {
    if (willDelete) {
      this.post();
    } 
  });
}} type="button" class="btn btn-light float-right m-2" >Zapisz</button>
</div>
</div>

</div>
</React.Fragment>
);
}
}


